(window as any).__Zone_disable_requestAnimationFrame = true;
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['drag', 'message', 'mousemove', 'pointermove', 'scroll', 'wheel'];